import React from 'react';
import { Flex } from '@skin-seoul/design-system';
import ProductCardAddToCart from '../components/ProductCardAddToCart';

type ProductCardContentProps = {
  children: React.ReactNode;
};

export const HorizontalProductCardContent = ({ children }: ProductCardContentProps) => {
  return (
    <Flex position="relative" width="100%" height="100%">
      <Flex
        flexDirection="column"
        width="100%"
        paddingRight={2}
        paddingLeft={4}
        paddingTop={3}
        paddingBottom={2}
        minWidth={0}
        gap={1}
        borderRadius="0 8px 8px 0px"
      >
        <Flex direction="column" alignItems="start" gap={2} justifyContent="center" width="100%">
          <>{children}</>
        </Flex>
        <ProductCardAddToCart />
      </Flex>
    </Flex>
  );
};
